module.exports = __webpack_public_path__ + "static/img/16.8a09814.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/16.png
// module id = Yi/z
// module chunks = 0